import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Typography from "@mui/material/Typography";
import { SERIES_COLORS } from "./palette";

export interface HBarItem { key: string; label: string; value: number; display?: string; muted?: boolean; color?: string }
export type HBarListProps = { items: HBarItem[]; onItemClick?: (key: string) => void; ariaLabel: string; emptyText?: string };

const TRACK = "#eef1f4";
const MUTED = "#b7c3cc";

// "R$ não antecipado", "Motivos", "Expirados por empresa": rótulo, barra proporcional ao maior e valor clicável. MUI puro.
export function HBarList({ items, onItemClick, ariaLabel, emptyText = "Sem dados no período" }: HBarListProps) {
  if (items.length === 0) return <Typography variant="body2" color="text.secondary">{emptyText}</Typography>;
  const max = Math.max(...items.map((i) => i.value), 1);
  return (
    <Box role="group" aria-label={ariaLabel} sx={{ display: "grid", gap: "8px" }}>
      {items.map((it) => (
        <ButtonBase key={it.key} aria-label={`${it.label} ${it.display ?? it.value}`} onClick={() => onItemClick?.(it.key)} disabled={!onItemClick}
          sx={{ display: "grid", gridTemplateColumns: "minmax(96px, 1fr) 2fr auto", gap: "12px", alignItems: "center", textAlign: "left", borderRadius: "4px", "&.Mui-disabled": { color: "inherit" } }}>
          <Typography variant="body2">{it.label}</Typography>
          <Box sx={{ bgcolor: TRACK, borderRadius: "3px", height: "10px" }}>
            <Box data-testid={`hbar-${it.key}`} sx={{ height: "10px", borderRadius: "3px", width: `${Math.round((it.value / max) * 100)}%`, bgcolor: it.color ?? (it.muted ? MUTED : SERIES_COLORS[0]) }} />
          </Box>
          <Typography variant="body2" fontWeight={600} sx={{ textDecoration: onItemClick ? "underline dashed" : "none" }}>{it.display ?? it.value}</Typography>
        </ButtonBase>
      ))}
    </Box>
  );
}
